import React from 'react'
import { CFooter } from '@coreui/react'
import moment from 'moment'

const AppFooter = () => {
    return <CFooter>
        <div>
            <span className="ms-1">&copy; {moment()?.format('YYYY')} AFA Community.</span>
        </div>
    </CFooter>
}

export default React.memo(AppFooter)
